module.exports = __webpack_public_path__ + "static/media/garden.b90147b9.svg";